export const enum GambleAction {
  Start = 'start',
  Gamble = 'gamble',
  CashOut = 'cashOut',
}

export interface GambleRequestParams<Data = any> {
  action: GambleAction;
  data?: Data;
}
